import {
  CLOSE_ALL_MODALS,
  CLOSE_FIXED_MODAL,
  FULLY_DISMISS_MODAL,
  OPEN_DELETE_METER_MODAL,
  OPEN_FIXED_MODAL,
  OPEN_MOBILE_DOWNLOAD_MODAL,
  OPEN_PASSWORD_MODAL,
  OPEN_PASSWORD_RESET_NOTIFICATION_MODAL,
  OPEN_REFERRAL_PROGRESS_MODAL,
  OPEN_REFUND_MODAL,
  OPEN_REF_MODAL,
  OPEN_TOPUP_MODAL,
  OPEN_UNIT_CALC_MODAL,
  OPEN_VTU_DATA_OPTION_MODAL,
  TOGGLE_DUPLICATE_TRANSACTION_MODAL,
  TOGGLE_TICKET_SUCCESS_MODAL,
  TOGGLE_WARNING_MODAL,
} from "../actions/modalActions";

const initModalState = {
  referral: false,
  password: false,
  unitCalc: false,
  mobileDownload: false,
  isDismissed: false,
  isFullyDismissed: false,
  deleteMeter: false,
  warningModal: false,
  ticketSuccessModal: false,
  duplicateTransactionModal: false,
  passwordResetNotificationModal: false,
  referralProgress: false,
  data: {},
  openRefundModal: false,
  openTopUpModal: false,
  openVtuDataOptionModal: false,
};

export default (state = initModalState, action) => {
  switch (action.type) {
    case CLOSE_ALL_MODALS:
      // Use new slice of state perhaps for next sticky footer. Since current will be persisted.
      // return initModalState;
      return {
        ...initModalState,
        isDismissed: state.isDismissed,
        isFullyDismissed: state.isFullyDismissed,
        // Keep the data so modals can safely check if their data is available before rendering
        data: state.data,
      };

    case OPEN_REF_MODAL:
      return { ...state, referral: true };

    case OPEN_UNIT_CALC_MODAL:
      return { ...state, unitCalc: true, data: action.data };

    case OPEN_PASSWORD_MODAL:
      return { ...state, password: true };

    case OPEN_MOBILE_DOWNLOAD_MODAL:
      return { ...state, mobileDownload: true, data: action.data || {} };

    case OPEN_DELETE_METER_MODAL:
      return { ...state, deleteMeter: true, data: action.data };

    case CLOSE_FIXED_MODAL:
      return { ...state, isDismissed: true };

    case OPEN_FIXED_MODAL:
      return { ...state, isDismissed: false };

    case FULLY_DISMISS_MODAL:
      return { ...state, isFullyDismissed: true };

    case TOGGLE_WARNING_MODAL:
      return {
        ...state,
        warningModal: action.data.open || true,
        data: action.data,
      };

    case TOGGLE_TICKET_SUCCESS_MODAL:
      return {
        ...state,
        ticketSuccessModal: action.data.open || true,
        data: action.data,
      };

    case TOGGLE_DUPLICATE_TRANSACTION_MODAL:
      return {
        ...state,
        duplicateTransactionModal: action.data.open,
        data: action.data,
      };

    case OPEN_REFUND_MODAL:
      return { ...initModalState, openRefundModal: true, data: action.data };

    case OPEN_TOPUP_MODAL:
      return { ...initModalState, openTopUpModal: true, data: action.data };
    case OPEN_PASSWORD_RESET_NOTIFICATION_MODAL:
      return { ...state, passwordResetNotificationModal: true };

    case OPEN_VTU_DATA_OPTION_MODAL:
      return { ...state, openVtuDataOptionModal: true };

    case OPEN_REFERRAL_PROGRESS_MODAL:
      return { ...state, referralProgress: true, data: action.data };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js